/* istanbul ignore file */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
} from '@material-ui/core';
import { toast } from 'react-toastify';

import { get, isNil } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { FormControl, Select, MenuItem } from '@material-ui/core';
import {
  CLAIM_STATUS,
  VEHICULE,
  PARTIES_CLAIM_STATUS,
} from 'containers/data-structure';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { translate } from 'containers/services/translate';
import messages from 'containers/RecapManagerPage/messages';
import { COLORS } from 'constants/design';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { formatVictimPayloadToInsert } from 'containers/RecapManagerPage/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import { resolveSagisClaim } from 'helpers/utils';
import {
  addPriorityReasonProfession,
  removeRejectedVictims,
} from 'services/utils';
import { PROFESSION_CODES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { VICTIM_PROFESSION_PRIORITY_CLAIM_ID } from 'services/constants';

const StyledDiv = styled.div`
  width: 576px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .select {
    width: 90%;
    margin-bottom: 33px;
    font-size: 13px;
  }
`;
const StyledDialogActions = styled(DialogActions)`
  display: flex;
  padding: 20px 30px;
  justify-content: space-between;

  .moveButton {
    border: 1px solid ${COLORS.YELLOW};
    background-color: ${COLORS.YELLOW};
    color: ${COLORS.LIMED_SPURCE};
    &:hover {
      background-color: ${COLORS.YELLOW};
    }
  }

  .Mui-disabled {
    opacity: 0.6;
  }
`;

export interface DecisionPartiesDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  requestValidateVictim?: Function;
  parties: any;
  policyInfo?: { sagis: {} };
  isVehicle: boolean;
  requestValidateVehicle?: Function;
  victims?: any;
  listings?: any;
  claimInfo?: any;
}

const DecisionPartiesDialog: React.FC<DecisionPartiesDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [decision, setDecision] = React.useState('');
  const [reason, setReason] = React.useState(null);

  const dropDownMenuElements = [
    {
      title: translate(messages.validate, props),
      value: PARTIES_CLAIM_STATUS.VALIDATED,
    },
    {
      title: translate(messages.reject, props),
      value: PARTIES_CLAIM_STATUS.REJECTED,
    },
  ];
  const handleChange = (event: any) => {
    setDecision(event.target.value);
  };
  const handleChangeReason = (event: any) => {
    setReason(event.target.value);
  };
  const successCallBackAddVictims = () => {
    toast.success(translate(messages.decisionValidationToast, props));
  };
  const successCallBackAddVehicle = () => {
    toast.success(translate(messages.decisionValidationToast, props));
  };

  const validateDialog = () => {
    const riskKey =
      props.policyInfo &&
      get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []).find(
        (element: { riskName: string }) => element.riskName === rcCoporeal,
      )?.riskId;
    const claimResponsabilityRate =
      props.policyInfo &&
      get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []).find(
        (element: { riskName: string }) => element.riskName === rcCoporeal,
      )?.responsibilityRate;
    const claimNumber = get(resolveSagisClaim(props.policyInfo), 'code');
    const victimsSagis = formatVictimPayloadToInsert(
      props.parties,
      claimNumber,
      riskKey,
      claimResponsabilityRate,
      props.listings,
    );

    if (props.isVehicle) {
      props.requestValidateVehicle &&
        props.requestValidateVehicle(
          {
            claimNumbers: claimNumber,
            riskKey,
            decisionVehicle: {
              id: get(props.parties, 'decision.id'),
              status: decision,
              reason: reason,
              vehicleId: get(props.parties, 'decision.vehicleId'),
            },
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
            vehicleSagis: {
              firstName: isNil(props.parties[VEHICULE.FIRST_NAME])
                ? '..'
                : props.parties[VEHICULE.FIRST_NAME],
              lastName: isNil(props.parties[VEHICULE.LAST_NAME])
                ? '..'
                : props.parties[VEHICULE.LAST_NAME],
              registrationNumber: get(
                props.parties,
                [VEHICULE.REGISTRATION_NUMBER],
                '',
              ),
              insuranceCompanyCode: get(
                props.parties,
                [VEHICULE.OPPOSING_PARTY],
                '',
              ),
              claimNumber: claimNumber,
              RiskID: riskKey,
            },
            vehicles: props.parties,
            id: get(props.parties, 'claimId'),
            claimInfo: {
              id: get(props.parties, 'claimId'),
              status: CLAIM_STATUS.VALIDATED,
            },
          },
          successCallBackAddVehicle,
        );
      props.onClose();
    } else {
      props.requestValidateVictim &&
        props.requestValidateVictim(
          {
            victimsSagis: victimsSagis?.victimsSagis,
            claimNumbers: claimNumber,
            riskKey,
            decisionVictim: {
              id: get(props.parties, 'decision.id'),
              status: decision,
              reason: reason,
            },
            victims: [props.parties],
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
            id: get(props.parties, 'claimId'),
            claimInfo: {
              id: get(props.parties, 'claimId'),
              status: CLAIM_STATUS.VALIDATED,
              priorityReasonId:
                decision === PARTIES_CLAIM_STATUS.REJECTED
                  ? addPriorityReasonProfession(
                      get(props.claimInfo, 'priorityReasonId'),
                      !!removeRejectedVictims(props.victims)
                        .filter((el: any) => el.id != get(props.parties, 'id'))
                        .find((v: any) =>
                          PROFESSION_CODES.includes(v.professionCode),
                        ),
                      props.listings,
                    )
                    ? addPriorityReasonProfession(
                        get(props.claimInfo, 'priorityReasonId'),
                        !!removeRejectedVictims(props.victims)
                          .filter(
                            (el: any) => el.id != get(props.parties, 'id'),
                          )
                          .find((v: any) =>
                            PROFESSION_CODES.includes(v.professionCode),
                          ),
                        props.listings,
                      )
                    : addPriorityReasonProfession(
                        get(props.claimInfo, 'priorityReasonId'),
                        !!PROFESSION_CODES.includes(
                          props.parties.professionCode,
                        ),
                        props.listings,
                      ) &&
                      get(props.claimInfo, 'priorityReasonId') ===
                        VICTIM_PROFESSION_PRIORITY_CLAIM_ID
                    ? null
                    : undefined
                  : addPriorityReasonProfession(
                      get(props.claimInfo, 'priorityReasonId'),
                      !!PROFESSION_CODES.includes(props.parties.professionCode),
                      props.listings,
                    ),
            },
          },
          successCallBackAddVictims,
        );
      props.onClose();
    }
  };
  return (
    <Dialog
      onClose={() => onClose()}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        {translate({ ...messages.dialogDecisionTitle }, props)}
      </DialogTitle>
      <DialogContent>
        <StyledDiv>
          <FormControl className="select">
            <Select
              name={'decision'}
              value={decision}
              onChange={handleChange}
              labelWidth={60}
            >
              {dropDownMenuElements.map(val => (
                <MenuItem value={val.value}>{val.title}</MenuItem>
              ))}
            </Select>
            {decision && (
              <div style={{ marginTop: 10 }}>
                <TextField
                  onChange={handleChangeReason}
                  name={'reason'}
                  value={reason}
                  label={translate(
                    decision === PARTIES_CLAIM_STATUS.REJECTED
                      ? { ...messages.reason }
                      : { ...messages.comment },
                    props,
                  )}
                  className="input"
                  multiline
                  fullWidth
                />
              </div>
            )}
          </FormControl>
        </StyledDiv>
      </DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          title={translate({ ...messages.assignmentDialogCancelButton }, props)}
        />
        <PrimaryButton
          onClick={validateDialog}
          disableElevation
          title={translate(
            { ...messages.assignmentDialogValidationButton },
            props,
          )}
          disabled={decision === PARTIES_CLAIM_STATUS.REJECTED && !reason}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

DecisionPartiesDialog.defaultProps = {
  open: false,
};

export default injectIntl(DecisionPartiesDialog);
